export class SharesLink {
	public id: number;
	public name: string;
	public view: boolean;
	public annotate: boolean;
	public download: boolean;
	public updateDocument: boolean;
	public delete: boolean;
	public updateMetadata: boolean;
	public create: boolean;
	public comment: boolean;
	public coauthor: boolean;
	public removeFromShare: boolean;
	public scope: number;
	public org: number;
	public group: number;
	public user: number;
	public users: number[];

	constructor() {
		this.id = -1;
		this.name = '';
		this.view = true;
		this.annotate = false;
		this.download = false;
		this.updateDocument = false;
		this.delete = false;
		this.updateMetadata = false;
		this.create = false;
		this.comment = false;
		this.coauthor = false;
		this.removeFromShare = false;
		this.scope = 1;
		this.org = -1;
		this.group = -1;
		this.user = -1;
		this.users = [];
	}
}